import * as d3 from 'd3';
import PropTypes from 'prop-types';
import React from 'react';

import AxesAndGrids from './AxesAndGrids';
import Defs from './Defs';
import Tooltip from './Tooltip';
import Trend from './Trend';
import Wrapper from './Wrapper';

export default function TrendChart({
  metricData,
  selected,
  customTooltip,
  tooltipWidth,
  tooltipHeight,
}) {
  return (
    <Wrapper
      data={metricData}
      selected={selected}
      keys={{ x: 'date', y: 'data' }}
      keyTypes={{ x: 'time' }}
      domChildren={
        <Tooltip
          customTooltip={customTooltip}
          tooltipWidth={tooltipWidth}
          tooltipHeight={tooltipHeight}
        />
      }
    >
      <Defs />
      <AxesAndGrids
        grid={{ horizontal: true }}
        options={{
          axisFormat: { x: d3.timeFormat('%m/%d'), y: d3.format(',') },
        }}
      />
      <Trend />
    </Wrapper>
  );
}

TrendChart.propTypes = {
  metricData: PropTypes.array.isRequired,
  customTooltip: PropTypes.func,
  tooltipWidth: PropTypes.number,
  tooltipHeight: PropTypes.number,
};
